module.exports = __webpack_public_path__ + "static/media/scully-icon.7f7b135c.png";